/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import React from 'react';
import Spinner from 'react-bootstrap/Spinner'

const Searching = (props) => {

  return (
    <>
      <div>
        <small>loading </small> <Spinner animation="grow" variant="success" size={props.size ? props.size : "sm"}/>
        {/* <Spinner animation="grow" variant="warning" size={props.size ? props.size : "sm"}/>
        <Spinner animation="grow" variant="success" size={props.size ? props.size : "sm"}/> */}
      </div>
    </>
  )
}
export { Searching }
export default Searching;
